module.exports = __webpack_public_path__ + "static/img/11.c3a098a8.png";